import { makeStyles } from '@material-ui/core'
import { Drawer, Form, Input, Select } from 'antd'
import { useEffect, useState } from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../../data'
import { CTAButton } from '../../components'

const useStyles = makeStyles(theme => ({
    error: {
        fontSize: 18,
        color: 'red'
    }
}))

const { Option } = Select

const NewJobScheduler = ({ visible, close }) => {
    const [error, setError] = useState(null)
    const [toolList, setTools] = useState([])
    const classes = useStyles()
    const [form] = Form.useForm()
    const data = useData()
    const jobsScheduler = data.jobsScheduler()
    const tools = data.tools()

    const createScheduler = vals => {
        trackPromise(
            jobsScheduler.createScheduler(vals)
                .then(close)
                .catch(err => {
                    console.log(err)
                    if ('detail' in err) {
                        setError(err.detail)
                    }
                    setError("An error occured.")
                })
        )
    }

    // get a list of tools to use 
    const getTools = async () => {
        try {
            const allTools = await tools.getAllTools()
            setTools(allTools.map(t => ({ id: t.id, name: t.name, input_path: t.sample_input_file })))
        } catch (error) {
            console.log(error.message)
        }

    }

    /**
     * Get data required 
     */
    useEffect(() => {
        getTools()
        // eslint-disable-next-line
    }, [])

    const { promiseInProgress } = usePromiseTracker()

    return (
        <Drawer
            visible={visible}
            onClose={close}
            placement="right"
            closable={true}
            width={350}
            title="Create Job Scheduler"
        >
            <Form
                layout="vertical"
                onFinish={createScheduler}
                form={form}
            >
                <Form.Item label="Day" name="day" rules={[{ required: true, message: 'Day is required' }]}>
                    <Select>
                        <Option value="Everyday">Everyday</Option>
                        <Option value="Monday">Monday</Option>
                        <Option value="Tuesday">Tuesday</Option>
                        <Option value="Wednesday">Wednesday</Option>
                        <Option value="Thursday">Thursday</Option>
                        <Option value="Friday">Friday</Option>
                        <Option value="Saturday">Saturday</Option>
                        <Option value="Sunday">Sunday</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="Tool" name="tool" rules={[{ required: true, message: 'Tool is required' }]}>
                    <Select placeholder="Select a tool" >
                        {
                            toolList.map(t => <Option value={t.id} key={t.id}>{t.id} - {t.name}</Option>)
                        }
                    </Select>
                </Form.Item>
                <Form.Item label="Concurrency Factor" name="concurrency_factor" rules={[{ required: true, message: 'Concurrency Factor is required' }]}>
                    <Input />
                </Form.Item>

                <Form.Item>
                    <CTAButton loading={promiseInProgress} type="submit"><>Submit</></CTAButton>
                </Form.Item>
                {
                    error && (
                        <Form.Item>
                            <p className={classes.error}>{error}</p>
                        </Form.Item>
                    )
                }

            </Form>
        </Drawer>
    )
}

export default NewJobScheduler
